export default {
    install(Vue, options) {
        Vue.mixin({
            data: () => ({
                headerTitle: 'Админ панель',
            }),

            methods: {
                setHeaderTitle(title) {
                    document.title = `${this.headerTitle} - ${title}`
                }
            },

            mounted() {

            }
        });
    }
};
